import {
  FAShippingMethodChoice,
  OrderStepChoice,
  StoreOrderSteps,
} from '../../../../../../../services/hookService/getOrderDetails/helper';
import {IDeliveryOrder} from '../../../../../../../services/hookService/getOrderDetails/types';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';

interface IProps {
  createdDate: string | null;
  supplyDate: string | null;
  totalOrderPrice: number;
  delivery: IDeliveryOrder | null;
  address: IProfileAddress | null;
  step: number;
}

const MyStoreOrderInformation = ({
  createdDate,
  supplyDate,
  totalOrderPrice,
  delivery,
  address,
  step,
}: Partial<IProps>) => {
  const isDeliveryInPerson = !Boolean(address?.guid);
  const deliveryMethod = delivery?.shipping_method
    ? FAShippingMethodChoice[delivery?.shipping_method] +
      ' - هزینه بر عهده خریدار'
    : 'مشخص نشده';

  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-zinc-500">اطلاعات سفارش</span>

      <div className="p-3 space-y-2 bg-zinc-100 rounded-xl text-md">
        {
          <InfoRow
            icon="icon-nameCalendar"
            label="تاریخ ثبت"
            value={createdDate ?? 'مشخص نشده'}
          />
        }
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ دریافت"
          value={supplyDate ?? 'مشخص نشده'}
        />
        <InfoRow
          icon="icon-namemoney"
          label="مبلغ کل سفارش"
          value={
            totalOrderPrice
              ? totalOrderPrice.toLocaleString() + ' تومان '
              : 'مشخص نشده'
          }
        />
        {step !== OrderStepChoice.COMPLETED && (
          <>
            <InfoRow
              icon="icon-nameDelivery-Boxes-2"
              label="نوع تحویل"
              value={isDeliveryInPerson ? 'تحویل حضوری' : 'ارسال فروشنده'}
            />
            {!isDeliveryInPerson &&
              (step === StoreOrderSteps.PENDING_PAYMENT_REVIEW ||
                step === StoreOrderSteps.PAYMENT_RECEIVED) && (
                <InfoRow
                  icon="icon-truck"
                  label="نوع ارسال"
                  value={deliveryMethod}
                />
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default MyStoreOrderInformation;
